<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px" />

          <div class="row mb-2">
            <div class="col-sm-12">
              <div v-if="flag">
                <span class="badge badge-success">Total Search Data Found: {{ trade_trainees.length }}</span>
                <download-excel class="btn btn-light float-right" :fetch="fetchData" :fields="trade_fields"
                  :meta="json_meta" worksheet="Trainee" name="trade.xls">
                  Download Excel
                </download-excel>

                <button class="btn btn-light float-right mr-1" @click="dowonloadPdf">
                  <div v-if="loading" class="spinner-border spinner-border-sm text-muted" style="margin-bottom : 2px;">
                  </div>
                  Download PDF
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
                <tr>
                  <th>Sl</th>
                  <th>Mouza Name</th>
                  <th>Completed</th>
                  <th>Ongoing</th>
                  <th>Male</th>
                  <th>Female</th>
                  <th>Total Trainee</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(trade_trainee, index) in trade_trainees" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ trade_trainee.desc }}</td>
                  <td>{{ completedTraineeCount(trade_trainee.batch) }}</td>
                  <td>{{ ongoingTraineeCount(trade_trainee.batch) }}</td>
                  <td>{{ trade_trainee.batch ? countMale(trade_trainee.batch) : 0 }}</td>
                  <td>{{ trade_trainee.batch ? countFemale(trade_trainee.batch) : 0 }}</td>
                  <td>{{ batchTraineeCount(trade_trainee.batch) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="trade_trainees.length === 0" class="loader">Loading...</div>
          <h5 v-if="trade_trainees.length === 0 && flag === true" class="text-center text-secondary">
            No Data Found
          </h5>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import moment from "moment";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
  page: {
    title: "Trade Information",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      loading: false,
      title: "Trade Information",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Trade Information",
          active: true
        }
      ],
      trade_trainees: [],
      trade_fields: {
        'Trade Name': 'desc',
        'Total Trainee': {
          callback: (value) => {
            let trainee_count = 0;
            value.batch.forEach((single_batch) => {
              trainee_count += single_batch.trainees.length;
            })
            return `${value.batch ? trainee_count : 0}`;
          }
        },
        'Ongoing Trainee': {
          callback: (value) => {
            let ongoing_count = 0;
            value.batch.forEach((single_batch) => {
              if ((single_batch.end_date >= this.current_date) && (single_batch.start_date <= this.current_date)) {
                ongoing_count += single_batch.trainees.length;
              }
            })
            return `${value.batch ? ongoing_count : 0}`;
          }
        },
        'Completed Trainee': {
          callback: (value) => {
            let completed_count = 0;
            value.batch.forEach((single_batch) => {
              if ((single_batch.end_date < this.current_date)) {
                completed_count += single_batch.trainees.length;
              }
            })
            return `${value.batch ? completed_count : 0}`;
          }
        },
        'Male Trainee': {
          callback: (value) => {
            let count = 0;
            value.batch.forEach((single_batch) => {
              single_batch.trainees.filter(p => {
                if (p.c_rep_gender_id !== null && p.c_rep_gender_id == 1) {
                  count += 1;
                } else if (p.c_rep_gender_id === null && p.c_gender_id == 1) {
                  count += 1;
                }
              });
            });
            return `${value.batch ? count : 0}`;
          }
        },
        'Female Trainee': {
          callback: (value) => {
            let count = 0;
            value.batch.forEach((single_batch) => {
              single_batch.trainees.filter(p => {
                if (p.c_rep_gender_id !== null && p.c_rep_gender_id == 2) {
                  count += 1;
                } else if (p.c_rep_gender_id === null && p.c_gender_id == 2) {
                  count += 1;
                }
              });
            });

            return `${value.batch ? count : 0}`;
          }
        },
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      flag: false,
      current_date: ''
    };
  },

  mounted() {
    this.getTradeTrainee();
    this.checkCurrentDate();
  },
  methods: {
    async dowonloadPdf() {
      this.loading = true
      let response = await http.post("api/trade/trainee/list/download");
      var data = []
      try {
        // console.log(response.data.trade_trainees)
        // return
        response.data.trade_trainees.forEach(function (value) {
          let current_date = moment().format("YYYY-MM-DD")
          //total batch trainee count
          let trainee_count = 0;
          value.batch.forEach((single_batch) => {
            trainee_count += single_batch.trainees.length;
          })
          // ongoing
          let ongoing_count = 0;
          value.batch.forEach((single_batch) => {
            if ((single_batch.end_date >= current_date) && (single_batch.start_date <= current_date)) {
              ongoing_count += single_batch.trainees.length;
            }
          })
          //male count
          let maleCount = 0;
          value.batch.forEach((single_batch) => {
            single_batch.trainees.filter(p => {
              if (p.c_rep_gender_id !== null && p.c_rep_gender_id == 1) {
                maleCount += 1;
              } else if (p.c_rep_gender_id === null && p.c_gender_id == 1) {
                maleCount += 1;
              }
            });
          });

          //female count
          let femaleCount = 0;
          value.batch.forEach((single_batch) => {
            single_batch.trainees.filter(p => {
              if (p.c_rep_gender_id !== null && p.c_rep_gender_id == 2) {
                femaleCount += 1;
              } else if (p.c_rep_gender_id === null && p.c_gender_id == 2) {
                femaleCount += 1;
              }
            });
          });

          data.push([
            value.desc,
            trainee_count,
            ongoing_count,
            maleCount,
            femaleCount,
            maleCount + femaleCount,
          ])
        })
      }
      catch (e) {
        console.log(e.message)
      }

      const doc = new jsPDF()
      autoTable(doc, {
        head: [['Mouza name', 'Completed', 'Ongoing', 'Male', 'Female', 'Total trainee']],
        body: data,
      })
      doc.save('trainee-trade-report.pdf')
      this.loading = false
    },
    getTradeTrainee() {
      http.get("api/trade/trainee/list").then(response => {
        if (!response.error) {
          this.flag = true;
          this.trade_trainees = response.data.trade_trainees;
        }
      });
    },
    batchTraineeCount(batch) {
      let trainee_count = 0;
      batch.forEach((value, index) => {
        trainee_count += value.trainees.length;
      })
      return trainee_count;
    },
    ongoingTraineeCount(batch) {
      let ongoing_count = 0;
      batch.forEach((value, index) => {
        if ((value.end_date >= this.current_date) && (value.start_date <= this.current_date)) {
          ongoing_count += value.trainees.length;
        }
      })
      return ongoing_count;
    },
    completedTraineeCount(batch) {
      let completed_count = 0;
      batch.forEach((value, index) => {
        if ((value.end_date < this.current_date)) {
          completed_count += value.trainees.length;
        }
      })
      return completed_count;
    },
    countMale(batch) {
      let count = 0;
      batch.forEach((value) => {
        value.trainees.filter(p => {
          if (p.c_rep_gender_id !== null && p.c_rep_gender_id == 1) {
            count += 1;
          } else if (p.c_rep_gender_id === null && p.c_gender_id == 1) {
            count += 1;
          }
        });
      })
      return count;
    },
    countFemale(batch) {
      let count = 0;
      batch.forEach((value) => {
        value.trainees.filter(p => {
          if (p.c_rep_gender_id !== null && p.c_rep_gender_id == 2) {
            count += 1;
          } else if (p.c_rep_gender_id === null && p.c_gender_id == 2) {
            count += 1;
          }
        });
      });
      return count;
    },
    checkCurrentDate() {
      this.current_date = moment().format("YYYY-MM-DD");
    },
    async fetchData() {
      const response = await http.post("api/trade/trainee/list/download");
      return response.data.trade_trainees;
    },
  },
};
</script>
<style>
.loader {
  color: #277ab9;
  font-size: 20px;
  margin: 100px auto;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: load4 1.3s infinite linear;
  animation: load4 1.3s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

@-webkit-keyframes load4 {

  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }

  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }

  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }

  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }

  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }

  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }

  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }

  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}

@keyframes load4 {

  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }

  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }

  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }

  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }

  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }

  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }

  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }

  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
</style>
